import user from './user'
import permissions from './permissions'

export default [
  ...user,
  ...permissions,
]
